import { useState } from "react";

import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import {
  useAddCommissionExclusion,
  WorkerCommissionExclusionReason,
} from "@/entities/worker";
import { Button } from "@/shared/ui/button";
import { Modal } from "@/shared/ui/Modal";
import { Textarea } from "@/shared/ui/textarea";
import {
  addCommissionExclusionSchema,
  AddCommissionExclusionSchema,
} from "../model/schema";

type AddCommissionExclusionModalProps = {
  workerId: string;
};

export const AddCommissionExclusionModal = ({
  workerId,
}: AddCommissionExclusionModalProps) => {
  const [open, setOpen] = useState(false);

  const { mutateAsync } = useAddCommissionExclusion({ workerId });

  const form = useForm<AddCommissionExclusionSchema>({
    defaultValues: {
      comment: "",
      reason: WorkerCommissionExclusionReason.OTHER,
    },
    resolver: zodResolver(addCommissionExclusionSchema),
  });

  const onSubmit = async (data: AddCommissionExclusionSchema) => {
    await mutateAsync(data);
    setOpen(false);
  };

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <Modal.Trigger variant="default" className="text-textInvertedColor">
        Добавить новое ограничение
      </Modal.Trigger>
      <Modal.Content className="gap-7">
        <form
          className="flex flex-col gap-7"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <Modal.Title>Новое ограничение</Modal.Title>
          <Textarea
            {...form.register("comment")}
            className="min-h-44"
            placeholder="Описание"
          />
          <div className="flex flex-col gap-2">
            <Button>Добавить новое ограничение</Button>
            <Modal.Close />
          </div>
        </form>
      </Modal.Content>
    </Modal>
  );
};
